<template>
	<ul class="v5-x-radiolist">
		<li v-for="(item, index) in currentData" :key="item.id" class="v5-x-radiolist-item">
			<label :for="`v5-x-radiolist-${uuid}-${index}`">
				<input type="radio" class="v5-x-radiolist-radio" :name="`v5-x-radiolist-${uuid}`" :id="`v5-x-radiolist-${uuid}-${index}`" :value="item.id" v-model="currentValue" @change="change">
				<slot :props="item"></slot>
			</label>
		</li>
	</ul>
</template>

<script>
import uuidMixin from './../../mixins/uuid';
export default {
	name: 'v5-x-radiolist',
	mixins: [uuidMixin],
	props: {
		options: {
			type: Array
		},
		value: {
			type: Object,
			default: () => {
				return {};
			}
		}
	},
	methods: {
		getValue(id) {
			return [].find.call(this.options, item => {
				return item.id === this.currentValue;
			});
		},
		change() {
			this.$emit('input', this.getValue());
		}
	},
	watch: {
		value(val) {
			this.currentValue = val['id'];
		},
		options(val) {
			this.currentData = val;
		}
	},
	data() {
		return {
			currentValue: this.value['id'],
			currentData: this.options
		};
	}
};
</script>

<style lang="scss">
@import './style.scss';
</style>



// WEBPACK FOOTER //
// index.vue?7072eb5a